import { useTranslations } from '@vocab/react';
import { Drawer, Text } from 'braid-design-system';
import React, { type FunctionComponent } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import { PREVIEW_CLOSED_EVENTDATA } from 'src/app/analytics/preview';
import getTrackingAdapter from 'src/app/dataAnalytics';
import { OBJECT_PRESSED } from 'src/app/dataAnalytics/schema/constants';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import { actionUpdateIsPreviewOpen } from 'src/app/state/modules/app/isPreviewOpen';
import { sendLinkEvent } from 'src/app/utils/analytics';
import { Preview } from 'src/app/views/components/Preview';
import type AppState from 'src/types/appState';

import translations from './.vocab';

export const PreviewSection: FunctionComponent = () => {
  const { isPreviewOpen, tealium } = useSelector(
    (state: AppState) => ({
      isPreviewOpen: state.app.isPreviewOpen,
      tealium: state.tealium,
    }),
    shallowEqual,
  );

  const { t } = useTranslations(translations);

  const dispatch = useDispatch();

  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  const close = () => {
    dispatch(actionUpdateIsPreviewOpen(false));
    if (isPageAnalyticsEnabled) {
      const eventData = {
        eventName: OBJECT_PRESSED,
        objectInteraction: 'job_ad_preview_closed',
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      sendLinkEvent(tealium, PREVIEW_CLOSED_EVENTDATA);
    }
  };

  return (
    <Drawer
      id="preview"
      title={t('preview-title')}
      description={<Text tone="secondary">{t('preview-description')}</Text>}
      open={isPreviewOpen}
      onClose={() => close()}
      width="large"
    >
      <Preview />
    </Drawer>
  );
};
